/**
 * Labels for party list balance column (opening + invoice dues).
 * Positive customer balance = they owe you (receivable).
 * Positive supplier balance = you owe them (payable).
 */

const fmtInr = (absValue) =>
  `₹${Math.abs(Number(absValue) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export function getCustomerBalanceParts(value) {
  // API may omit `balance` on older responses; treat as 0 (not NaN from undefined)
  const raw = value === undefined || value === "" ? 0 : value;
  const n = Number(raw);
  if (Number.isNaN(n)) return null;
  if (Math.abs(n) < 0.005) return { primary: fmtInr(0), label: "Settled" };
  if (n > 0) return { primary: fmtInr(n), label: "Receivable" };
  return { primary: `−${fmtInr(n)}`, label: "Advance / Credit" };
}

export function getSupplierBalanceParts(value) {
  const raw = value === undefined || value === "" ? 0 : value;
  const n = Number(raw);
  if (Number.isNaN(n)) return null;
  if (Math.abs(n) < 0.005) return { primary: fmtInr(0), label: "Settled" };
  if (n > 0) return { primary: fmtInr(n), label: "Payable" };
  return { primary: `−${fmtInr(n)}`, label: "Advance / Prepaid" };
}
